<script setup>
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import SpeckleProjectSelection from '@/components/speckle/SpeckleProjectSelection.vue';
import SpeckleLoginRequired from '@/components/speckle/SpeckleLoginRequired.vue';
import SpeckleManagementTile from '@/components/speckle/SpeckleManagementTile.vue';
import SpeckleCalculationTable from '@/components/speckle/SpeckleCalculationTable.vue';

import { useCalculationStore } from '@/stores/calculation'
import { useSpeckleManagement } from '@/composables/useSpeckleManagement'

const route = useRoute()

const calculationStore = useCalculationStore()
const speckleManagement = useSpeckleManagement()

const { canUseSpeckle } = speckleManagement

onMounted(async () => {
  await calculationStore.fetchOptions()
  await calculationStore.fetchItems({ project: route.params.id })
})
</script>

<template>
  <SpeckleManagementTile />
  <v-card flat class="ma-4">
    <template v-if="canUseSpeckle">
      <SpeckleProjectSelection />
      <SpeckleCalculationTable />
    </template>
    <SpeckleLoginRequired v-else />
  </v-card>
</template>
